import React from 'react';
import Head from 'next/head';

import ErrorPage from '@zola/zola-ui/src/components/ErrorPage';
import { OuterContainer } from 'components/common/CustomErrorPage/CustomErrorPage.styles';
import dynamic from 'next/dynamic';

export type CustomErrorPageProps = {
  statusCode?: number;
};

const Footer = dynamic(
  () => import('@zola/zola-ui/src/components/Footer').then(module => module.Footer),
  { ssr: false }
);

const UnifiedNav = dynamic(() => import('components/common/header/UnifiedNav'), {
  ssr: false,
});

const CustomErrorPage = ({ statusCode }: CustomErrorPageProps): JSX.Element => {
  const pageMetaTitle = statusCode === 404 ? 'Not found' : 'Error occured';

  return (
    <OuterContainer>
      <Head>
        <title>{pageMetaTitle} - Zola</title>
      </Head>
      <UnifiedNav />
      <ErrorPage statusCode={statusCode || 404} />
      <Footer />
    </OuterContainer>
  );
};

export default CustomErrorPage;
